export { ResetPasswordPage } from "./ResetPasswordPage"
export type { ResetPasswordPageProps } from "./ResetPasswordPage"
